<template>
  <template v-if="showingButton">
    <Button ref="popoverAnchor" text size="small" severity="secondary" @click="showingPopover = true">
      Auxiliaries order
      <i class="pi pi-angle-down"></i>
    </Button>
    <Popover v-model:showingPopover="showingPopover" :popoverAnchor="popoverAnchor?.$el">
      <h3 style="padding: 15px; padding-bottom: 30px; text-align: center;">
        Auxiliaries order
      </h3>
      <ul style="display: flex; flex-direction: column; align-items: stretch; gap: 15px; padding-left: 30px; padding-right: 30px;">
        <TransitionGroup>
          <li v-for="(auxiliaryName, index) in auxiliariesOrder" :key="auxiliaryName" style="display: flex; align-items: center; gap: 15px;">
            <div style="flex-grow: 1;"></div>
            {{ auxiliaryName }}
            <Button text severity="secondary" style="width: 55px; justify-content: center;" @click="onClickOrdinal($event, index)">
              <span v-html="ordinalLabel(index)"></span>
            </Button>
          </li>
        </TransitionGroup>
      </ul>
      <Menu ref="ordinalMenu" popup :model="ordinalMenuItems">
        <template #item="{item, props}">
          <a v-ripple v-bind="props.action">
            <span v-html="item.label"></span>
          </a>
        </template>
      </Menu>
      <div style="display: flex; gap: 15px; margin-top: 30px;">
        <Button style="flex-grow: 1; flex-basis: 0; justify-content: center;" @click="ok()">
          Ok
        </Button>
        <Button severity="secondary" style="flex-grow: 1; flex-basis: 0; justify-content: center;" @click="cancel()">
          Cancel
        </Button>
      </div>
    </Popover>
  </template>
</template>

<script setup>
import store from "./store.js";
import { computed, ref } from "vue";
import { arrayMove, sortBy, unique } from "./utility.js";
import { ordinalLabel } from "./appUtility.js";
import Popover from "./Popover.vue";

let props = defineProps([
  "tag"
]);

let showingButton = computed(() => {
  let connectedSessions = store.sessions.filter(session => session.isConnected);
  let bins = connectedSessions.flatMap(session => session.system.bins.children);
  let auxiliaries = bins.flatMap(bin => bin.auxiliaries.children);
  let isAuxiliaryAggregate = props.tag.$parents().some(parent => auxiliaries.includes(parent));
  return (
    store.showAdvanced &&
    isAuxiliaryAggregate &&
    auxiliariesOrder.value.length > 1
  );
});

let popoverAnchor = ref();
let showingPopover = ref(false);
let auxiliariesOrder = ref(initAuxiliariesOrder());

function initAuxiliariesOrder() {
  let system = store.sessions[0].system;
  let connectedSessions = store.sessions.filter(session => session.isConnected);
  let sessionsInDisplayOrder = sortBy(connectedSessions, (session) => {
    let boardsOnSite = system.boardsOnSite.children;
    let sortIndex = boardsOnSite.findIndex(board =>
      board.macAddress.value == session.system.macAddr.value ||
      board.boardName.value == session.system.boardName.value
    );
    return sortIndex;
  });
  let bins = sessionsInDisplayOrder.flatMap(session => session.system.bins.children);
  let auxiliaries = bins.flatMap(bin => bin.auxiliaries.children);
  let auxiliariesOrder = system.auxiliariesOrder.value;
  let auxiliaryNames = unique([
    ... auxiliaries.map(auxiliary => auxiliary.name.value),
    ... auxiliariesOrder
  ]);
  let auxiliaryNamesSorted = partialSort(auxiliaryNames, auxiliariesOrder);
  return auxiliaryNamesSorted;
}

function partialSort(items, order) {
  let result = items.map(item => {
    let hasSpecifiedOrder = order.includes(item);
    return hasSpecifiedOrder ? null : item;
  });
  order.forEach(item => {
    let index = result.indexOf(null);
    result[index] = item;
  });
  return result;
}

let ordinalMenu = ref();
let ordinalMenuItems = ref([]);
function onClickOrdinal(event, auxiliaryIndex) {
  if (auxiliariesOrder.value.length == 2) {
    arrayMove(auxiliariesOrder.value, 0, 1);
  }
  else {
    ordinalMenuItems.value = auxiliariesOrder.value.map((auxiliaryName, index) => {
      return {
        label: ordinalLabel(index),
        command: () => arrayMove(auxiliariesOrder.value, auxiliaryIndex, index)
      };
    });
    ordinalMenu.value.toggle(event);
  }
}

function ok() {
  showingPopover.value = false;
  let connectedSessions = store.sessions.filter(session => session.isConnected);
  connectedSessions.forEach(session => {
    let system = session.system;
    session.changeSettings([
      { handle: system.auxiliariesOrder.handle, value: auxiliariesOrder.value }
    ]);
  });
}

function cancel() {
  showingPopover.value = false;
}
</script>

<style scoped>
.v-move,
.v-enter-active,
.v-leave-active,
.p-inputtext {
  transition: all 0.25s ease;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.v-leave-active {
  position: absolute;
}
</style>